import React from 'react'
import { Link } from 'react-router-dom'
;
import exam from "./assets/exam-time.png";
import survey from "./assets/survey.png";


const QuestionBank = () => {
    return (
        <div style={{ marginTop: "5.5rem" }}>
            <div className="container">
                <div className="row" style={{ marginLeft: "2px", marginRight: "2px" }}>
                    <div className="col-6" style={{ padding: "5px" }}>
                        <Link
                            to="/questions"
                            className="card card-hover rounded-4 shadow-sm p-10"
                        >
                            <div className="card-body text-center">
                                <img
                                    className="mb-2"
                                     src={survey}
                                    alt="Pick Questions"
                                    width={"50px"}
                                />
                                <h2 style={{ fontSize: "15px" }}>Questions</h2>
                            </div>
                        </Link>
                    </div>

                    <div className="col-6" style={{ padding: "5px" }}>
                        <Link
                            to={`/paper`}
                            className="card card-hover rounded-4 shadow-sm"
                        >
                            <div className="card-body text-center">
                                <img
                                    className="mb-2"
                                     src={exam}
                                    alt="Download Paper"
                                    width={"50px"}
                                />
                                <h2 style={{ fontSize: "15px" }}>Question Paper</h2>
                            </div>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default QuestionBank